// extracted by mini-css-extract-plugin
module.exports = {"list":"_1Kng9","listTitle":"_2sXdq","listItem":"_37Rqk","link":"_1wPuv"};